import { Select, FormLabel, Input, Box,} from '@chakra-ui/react'
import { useState } from 'react';

export default function AdresaHr({size='xs',mjesto="",ulkbr="",pbr="",posta="",opcina="",zupanija="",onChange,readonly=false}) {
    const [adresa, setAdresa] = useState({mj:mjesto,ulkbr:ulkbr,pbr:pbr,pst:posta,opc:opcina,zup:zupanija})
    const  adresaChanged=(event)=>{
        const _id=event.target.id;
        const _val=event.target.value;
        let _adr={...adresa};
        switch (_id) {
            case "inp_mj":
                _adr.mj=_val;  
                break;
            case "inp_ulkbr":
                _adr.ulkbr=_val;  
                break;
            case "inp_pbr":
                _adr.pbr=_val;  
                break;                
            case "inp_pst":
                _adr.pst=_val;  
                break;     
            case "inp_opc":
                _adr.opc=_val;  
                break;
            case "slc_zup":
                _adr.zup=_val;  
                break;  
            default:
                break;
        }
        onChange(_adr);
        setAdresa(_adr);
    }
  return (
    <Box display={'flex'} flexDir={'column'} gap={'0.5rem'} w='100%'>
        <Box display={'flex'} flexDir={'row'} w={'100%'} gap={'0.5rem'}>
            <Box w='50%'>
                <FormLabel fontSize={size}>Mjesto</FormLabel>
                <Input focusBorderColor='grunt2.400' id='inp_mj' size={size} maxLength={50} variant={'filled'} value={adresa.mj} onChange={adresaChanged} display={'block'} isReadOnly={readonly}></Input>
            </Box>
            <Box w='50%'>
                <FormLabel fontSize={size}>Ulica i kućni broj</FormLabel>
                <Input focusBorderColor='grunt2.400' id='inp_ulkbr' size={size} maxLength={50} variant={'filled'} value={adresa.ulkbr} onChange={adresaChanged} display={'block'} isReadOnly={readonly}></Input>
            </Box>
        </Box>
        <Box display={'flex'} flexDir={'row'} w={'100%'} gap={'0.5rem'}>
            <Box w='20%'>
                <FormLabel fontSize={size}>Poštanski broj</FormLabel>
                <Input focusBorderColor='grunt2.400' id='inp_pbr' size={size} maxLength={5} variant={'filled'} value={adresa.pbr} onChange={adresaChanged} display={'block'} isReadOnly={readonly}></Input>
            </Box>
            <Box w='40%'>
                <FormLabel fontSize={size}>Pošta</FormLabel>
                <Input focusBorderColor='grunt2.400' id='inp_pst' size={size} maxLength={50} variant={'filled'} value={adresa.pst} onChange={adresaChanged} display={'block'} isReadOnly={readonly}></Input>
            </Box>
            <Box w='40%'>
                <FormLabel fontSize={size}>Općina</FormLabel>
                <Input focusBorderColor='grunt2.400' id='inp_opc' size={size} maxLength={50} variant={'filled'} value={adresa.opc} onChange={adresaChanged} display={'block'} isReadOnly={readonly}></Input>
            </Box>
        </Box>
        <Box w='100%'>
            <FormLabel fontSize={size}>Županija</FormLabel>
            <Select focusBorderColor='grunt2.400' id='slc_zup' size={size} variant={'filled'}  maxLength={50} defaultValue={adresa.zup.toUpperCase()} isDisabled={readonly} onChange={adresaChanged}>
                    <option value="-">-</option>
                    <option value="ZAGREBAČKA">ZAGREBAČKA</option>
                    <option value="SISAČKO-MOSLAVAČKA">SISAČKO-MOSLAVAČKA</option>
                    <option value="KARLOVAČKA">KARLOVAČKA</option>
                    <option value="KRAPINSKO-ZAGORSKA">KRAPINSKO-ZAGORSKA</option>
                    <option value="VARAŽDINSKA">VARAŽDINSKA</option>
                    <option value="KOPRIVNIČKO-KRIŽEVAČKA">KOPRIVNIČKO-KRIŽEVAČKA</option>
                    <option value="BJELOVARSKO-BILOGORSKA">BJELOVARSKO-BILOGORSKA</option>
                    <option value="PRIMORSKO-GORANSKA">PRIMORSKO-GORANSKA</option>
                    <option value="LIČKO-SENJSKA">LIČKO-SENJSKA</option>
                    <option value="VIROVITIČKO-PODRAVSKA">VIROVITIČKO-PODRAVSKA</option>
                    <option value="POŽEŠKO-SLAVONSKA">POŽEŠKO-SLAVONSKA</option>
                    <option value="BRODSKO-POSAVSKA">BRODSKO-POSAVSKA</option>
                    <option value="ZADARSKA">ZADARSKA</option>
                    <option value="OSJEČKO-BARANJSKA">OSJEČKO-BARANJSKA</option>
                    <option value="ŠIBENSKO-KNINSKA">ŠIBENSKO-KNINSKA</option>
                    <option value="VUKOVARSKO-SRIJEMSKA">VUKOVARSKO-SRIJEMSKA</option>
                    <option value="SPLITSKO-DALMATINSKA">SPLITSKO-DALMATINSKA</option>
                    <option value="ISTARSKA">ISTARSKA</option>
                    <option value="DUBROVAČKO-NERETVANSKA">DUBROVAČKO-NERETVANSKA</option>
                    <option value="MEĐIMURSKA">MEĐIMURSKA</option>
                    <option value="GRAD ZAGREB">GRAD ZAGREB</option>
                </Select>
        </Box>
    </Box>
    
  )
}
